import Vue from 'vue'
import VueRouter, { Route, RouteConfig } from 'vue-router'
import Tutorials from "@/views/Tutorials.vue";
import Home from "@/views/Home.vue";
import TutorSessionView from "@/views/TutorSessionView.vue";
import { useUserServiceInject } from '@/context'
import { baseUrl } from '@/constants';

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      breadcrumb: [
        {
          text: 'Startseite',
        }
      ],
      navItem: '/',
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Login'
        }
      ],
      navItem: '/login',
    }
  },
  {
    path: "/logout",
    name: "Logout",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/Logout.vue"),
  },
  {
    path: '/tutorials',
    name: 'tutorials',
    component: Tutorials,
    meta: {
      breadcrumb: [
        {
          text: 'Tutorien',
        }
      ],
      navItem: '/tutorials',
    }
  },
  {
    path: '/tutorials/my-tutorial',
    name: 'tutorials.my-tutorial',
    component:() => import('../views/StudentTutorialView.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Tutorien',
          to: { name: 'tutorials'}
        },
        {
          text: 'Mein Tutorium',
        }
      ],
      isAuthenticeated: true,
      navItem: '/tutorials/my-tutorial',
    }
  },
  {
    path: '/tutorials/setting',
    name: 'tutorials.setting',
    component: () => import('../views/SettingsView.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Tutorien',
          to: { name: 'tutorials'}
        },
        {
          text: 'Profil',
        }
      ],
      isAuthenticeated: true,
      navItem: '/tutorials/setting',
    }
  },
  {
    path: '/tutorials/matching',
    name: 'tutorials.matching',
    component: () => import('../views/MatchingListView.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Tutorien',
          to: { name: 'tutorials'}
        },
        {
          text: 'Matching',
        }
      ],
      isTutor: true,
      navItem: '/tutorials/matching',
    }
  },
  {
    path: '/tutorials/setting/matching/:id',
    name: 'tutorials.matching.id',
    component: () => import('../views/MatchingView.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Tutorien',
          to: { name: 'tutorials'}
        },
        {
          text: 'Matching',
          to: { name: 'tutorials.matching '}
        }
      ],
      isTutor: true,
      navItem: '/tutorials/setting',
    }
  },
  {
    path: '/tutorials/my-tutorial/select',
    name: 'tutorials.my-tutorial.select',
    props: { id: -1 },
    component:() => import('../components/TutorialSelection.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Tutorien',
          to: { name: 'tutorials'}
        },
        {
          text: 'Mein Tutorium',
          to: { name: 'tutorials.my-tutorial' }
        }
      ],
      isAuthenticeated: true,
      navItem: '/tutorials/my-tutorial',
    }
  },
  {
    path:'/tutorials/sessions/:tutorialId/:sessionId',
    name: 'tutorials.id',
    component: TutorSessionView,
    meta: {
      breadcrumb: [
        {
          text: 'Tutorien',
          to: { name: 'tutorials'}
        },
        {
          text: 'Tutorstunde',
        }
      ],
      navItem: '/tutorials',
    }
  },
  {
    path: '/tutorials/profile/:username',
    component: () => import('../views/ProfileView.vue'),
    name: 'tutorials.profile.username',
    meta: {
      breadcrumb: [
        {
          text: 'Tutorien',
          to: { name: 'tutorials'}
        },
        {
          text: 'Meine Tutorien',
        }
      ],
      isAdmin: true,
      isTutor: true,
      navItem: '/tutorials/profile/',
    }
  },
  {
    path: '/tutorials/profile',
    component: () => import('../views/ProfileView.vue'),
    name: 'tutorials.profile',
    meta: {
      breadcrumb: [
        {
          text: 'Tutorien',
          to: { name: 'tutorials'}
        },
        {
          text: 'Meine Tutorien',
        }
      ],
      isAdmin: true,
      isTutor: true,
      navItem: '/tutorials/profile/',
    }
  },
  {
    path: '/tutorials/event',
    component: () => import('../views/EventView.vue'),
    name: 'tutorials.event',
    meta: {
      breadcrumb: [
        {
          text: 'Tutorien',
          to: { name: 'tutorials'}
        },
        {
          text: 'Ereignisse',
        }
      ],
      navItem: '/tutorials/event',
    }
  },
  {
    path: '/tutorials/admin',
    component: () => import('../views/TutorialsAdmin.vue'),
    name: 'tutorials.admin',
    meta: {
      breadcrumb: [
        {
          text: 'Tutorien',
          to: { name: 'tutorials'}
        },
        {
          text: 'Verwaltung',
        }
      ],
      isTutor: true,
      navItem: '/tutorials/admin',
    }
  },
  {
    path: '/tutorials/admin/addTutorials',
    name: 'tutorials.admin.addTutorials',
    component:() => import('../views/AddTutorialsView.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Tutorien',
          to: { name: 'tutorials'}
        },
        {
          text: 'Verwaltung',
          to: { name: 'tutorials.admin'}
        },
        {
          text: 'Hinzufügen'
        }
      ],
      isAdmin: true,
      navItem: '/tutorials/admin',
    }
  },
  {
    path: '/tutorials/admin/courses',
    name: 'tutorials.admin.courses',
    component:() => import('../views/CourseAdminView.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Tutorien',
          to: { name: 'tutorials'}
        },
        {
          text: 'Verwaltung',
          to: { name: 'tutorials.admin'}
        },
        {
          text: 'Kurse',
        }
      ],
      isAdmin: true,
      navItem: '/tutorials/admin',
    }
  },
  {
    path: '/tutorials/admin/courses/:id',
    name: 'tutorials.admin.course',
    component:() => import('../views/CourseView.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Tutorien',
          to: { name: 'tutorials'}
        },
        {
          text: 'Verwaltung',
          to: { name: 'tutorials.admin'}
        },
        {
          text: 'Kurse',
        }
      ],
      isAdmin: true,
      navItem: '/tutorials/admin',
    }
  },
  {
    path: '/tutorials/admin/statistics',
    name: 'tutorials.admin.statistics',
    component:() => import('../views/StatisticsView.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Tutorien',
          to: { name: 'tutorials'}
        },
        {
          text: 'Statistiken',
        },
      ],
      isAdmin: true,
      navItem: '/tutorials/admin/statistics',
    }
  },
    {
      path: '/about',
      name: 'about',
      component:() => import('../views/AboutView.vue'),
      meta: {
        breadcrumb: [
          {
            text: 'About',
          },
        ],
        navItem: '/about',
      }
    },

    {
      path: '/exercises',
      name: 'exercises',
      component:() => import('../views/Exercises.vue'),
      meta: {
        breadcrumb: [
          {
            text: 'Übungen',
          },
        ],
        navItem: '/exercises',
      }
    },
    {
      path: '/exercises/new',
      name: 'new.exercise',
      component:() => import('../views/CreateExerciseView.vue'),
      meta: {
        breadcrumb: [
          {
            text: 'Übungen',
            to: { name: 'exercises'}
          },
          {
            text: 'Hinzufügen',
          },
        ],
        navItem: '/exercises/new',
        isAdmin: true,
      }
    },
    {
      path: '/exercises/my-exercises',
      name: 'user.exercises',
      component:() => import('../views/UserExerciseView.vue'),
      meta: {
        breadcrumb: [
          {
            text: 'Übungen',
            to: { name: 'exercises'}
          },
          {
            text: 'Meine Übungen',
          },
        ],
        navItem: '/exercises/my-exercises',
        isAdmin: true,
      }
    },
    {
      path: '/exercises/correct',
      name: 'correct.exercises',
      component:() => import('../views/CorrectExerciseView.vue'),
      meta: {
        breadcrumb: [
          {
            text: 'Übungen',
            to: { name: 'exercises'}
          },
          {
            text: 'Korrigieren',
          },
        ],
        navItem: '/exercises/correct',
        isAdmin: true,
      }
    },
    {
      path: '/exercises/:id',
      name: 'exercise',
      component:() => import('../views/ExerciseView.vue'),
      meta: {
        breadcrumb: [
          {
            text: 'Übungen',
            to: { name: 'exercises'}
          },
        ],
        navItem: '/exercises',
      }
    },
    {
      path: '/exercises/update/:id',
      name: 'update.exercise',
      component:() => import('../views/UpdateExerciseView.vue'),
      meta: {
        breadcrumb: [
          {
            text: 'Übungen',
            to: { name: 'exercises'}
          },
          {
            text: 'Ändern',
          },
        ],
        navItem: '/exercises',
        isAdmin: true,
      }
    },
    {
      path: '/exercises/sheets/new',
      name: 'new.exercise-sheet',
      component:() => import('../views/CreateExerciseSheetView.vue'),
      meta: {
        breadcrumb: [
          {
            text: 'Übungen',
            to: { name: 'exercises'}
          },
          {
            text: 'Übungsblatt erstellen',
          },
        ],
        navItem: '/exercises',
        isAdmin: true,
      }
    },
    {
      path :'*',
      name: 'default',
      component: Home,
      meta: {
        breadcrumb: [
          {
            text: 'Startseite',
          }
        ],
        navItem: '/',
      }
    }
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

function getUserInfo() {
  const authInfo = {
    authenticeated: false,
    isAdmin: false,
    isTutor: false
  }
  const token = localStorage.getItem('accessToken')
  if (token == null) {
    return authInfo
  } else
    authInfo.authenticeated = true
  const userInfo = JSON.parse(decodeURIComponent(escape(window.atob(token.split('.')[1]))))
  if (userInfo.roles) {
    authInfo.isAdmin = userInfo.roles.includes('ADMIN')
    authInfo.isTutor = userInfo.roles.includes('TUTOR')
  }
  return authInfo
}

router.beforeEach((to: Route, from: Route, next) => {
  const info = getUserInfo();

  if (to && to.meta) {
    if (to!.meta!.isAuthenticeated) {
      if (info.authenticeated) next();
      else next({ name: "login" });
    } else if (to!.meta!.isTutor) {
      if (info.isTutor || info.isAdmin) next();
      else next(to!.meta!.breadcrumb![0].to);
    } else if (to!.meta!.isAdmin) {
      if (info.isAdmin) next();
      else next(to!.meta!.breadcrumb![0].to);
    } else {
      next();
    }
  } else {
    next()
  }
})

export default router
